import { ReactNode } from 'react';
import { DatabaseOutlined, FileTextOutlined } from '@ant-design/icons';
import IrelandImportH1PrefixIcon from 'components/icons/mirroring/IrelandImportH1PrefixIcon';
import { DeclarationMetaSource } from 'store/declarations/declaration-source-meta';

export const SOURCE_COLOURS: Record<
    DeclarationMetaSource | 'override',
    { color: string; backgroundColor: string; borderColor: string }
> = {
    TEMPLATE: {
        color: 'var(--purple-6)',
        backgroundColor: 'var(--purple-1)',
        borderColor: 'var(--brand-2)',
    },
    SYSTEM: {
        color: 'var(--gray-6)',
        backgroundColor: 'var(--purple-1)',
        borderColor: 'var(--brand-2)',
    },
    H1: {
        color: 'var(--polar-green-6)',
        backgroundColor: 'var(--polar-green-1)',
        borderColor: 'var(--polar-green-2)',
    },
    override: {
        color: 'var(--orange-6)',
        backgroundColor: 'var(--orange-1)',
        borderColor: 'var(--orange-2)',
    },
};

export const SOURCE_ICONS: Record<DeclarationMetaSource, ReactNode> = {
    TEMPLATE: <FileTextOutlined />,
    SYSTEM: <DatabaseOutlined />,
    H1: <IrelandImportH1PrefixIcon />,
};

const SOURCE_LABELS: Record<DeclarationMetaSource, string> = {
    TEMPLATE: 'the template',
    SYSTEM: 'the system',
    H1: 'the mirrored H1 declaration',
};

export const tooltip = (source: DeclarationMetaSource, overridden?: boolean) =>
    overridden
        ? `This value has been manually edited from ${SOURCE_LABELS[source]} data`
        : `This value comes from ${SOURCE_LABELS[source]}`;
